import { useStaticQuery } from "gatsby";
import React from "react";
import { useTranslation } from "react-i18next";
import { usePageContext } from "../../utils/PageContext";
import { HomePadding } from "../HomePadding";
import "./style.css";

export const query = graphql`
  query {
    api {
      configSocialMediaAndApp {
        facebookUrl
        androidUrl
        instagramUrl
        iosUrl
        linkedinUrl
        twitterUrl
        youtubeUrl
      }
    }
  }
`;

export const AppsBanner = () => {
  const apiData = useStaticQuery(query);
  const social = apiData.api.configSocialMediaAndApp;
  const { t } = useTranslation();
  const { lang } = usePageContext();

  return (
    <HomePadding>
      <div
        className="banner-payment"
        style={
          {
            // backgroundImage: `url("/images/fibank app.png")`,
            // backgroundRepeat: "no-repeat",
            // backgroundSize: "500px",
          }
        }
      >
        <div className="banner-payment__text">
          <div className="banner-payment__title">{t("appBanner.title")}</div>
          <div className="banner-payment__buttons">
            <a href={social.iosUrl} target="_blank" rel="noopener noreferrer">
              <img
                src={`/images/app_store___light_${lang}.svg`}
                alt="App Store"
              />
            </a>
            <a
              href={social.androidUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`/images/google_play___light_${lang}.svg`}
                alt="Google Play"
              />
            </a>
          </div>
          <p>{t("appBanner.description")}</p>
        </div>
        <div className="banner-payment__image">
          <img src="/images/fibank-app.png" alt="" />
        </div>
      </div>
    </HomePadding>
  );
};
